module.controller('corpDepositCtrl', ['$scope', '$http', '$rootScope', '$window', 'Session', 'baseURI', 'OVERLAY',
  function ($scope, $http, $rootScope, $window, Session, baseURI, OVERLAY){
    var url = baseURI + 'directdeposit';
    $scope.overlay = OVERLAY['member.home.corpdeposit'];
    $scope.formData = {};

    $scope.closeOrRedirect = function(){
      $rootScope.back();
    };

    $http.get(url).then(function (resp){
      var data = resp.data;

      $scope.AccountNumber = data.Data.Account;
      $scope.Routing = data.Data.Routing;
    }).catch(function (error){
      console.log('err', error);
    });
  }]);
